type Props = {
  isSelected: boolean;
};

export default function RadioMark({ isSelected }: Props) {
  return (
    <span
      className={`flex size-4 shrink-0 items-center justify-center rounded-full border ${
        isSelected ? 'border-black' : 'border-grey-divide'
      }`}
    >
      {isSelected ? <span className="size-2 rounded-full bg-black" /> : null}
    </span>
  );
}
